<template>
  <div class="page-wrap p-3">
    <div class="mt-3 mb-3">
      <a :href="`/professions-cost`">
        <span><i class="fa fa-chevron-left" aria-hidden="true"></i></span>
        Назад
      </a>
    </div>

    <div class="page-header p-3 mb-3 mt-3">
      <h4>Редактирование стоимости кредитов за {{professionCost.year}} год</h4>
      <h5>{{professionCost.profession.code}} {{professionCost.profession.nameRu}}</h5>
    </div>
  </div>
  <div class="page-content mt-3 mb-3">
    <div class="col-md-12">
      <div class="row col-md-10">
        <div class="el-input-group">
          <label for="sum" class="form-label col-md-5">
            Тип
          </label>
          <div class="col-md-7">

            <div class="row">
              <div class="col-auto">
                <input class="form-check-input" type="radio" name="type"
                       v-model="professionCost.type" :value="'CREDIT'">
                <label class="form-check-label ps-lg-1" for="byCredit">
                  Кредит
                </label>
              </div>
              <div class="col-auto">
                <input class="form-check-input" type="radio" name="type"
                       v-model="professionCost.type" :value="'MONTH'">
                <label class="form-check-label ps-lg-1" for="byMonth">
                 Месяц
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>


    <div class="col-md-12">
      <div class="row col-md-10">
        <div class="el-input-group">
          <label for="sum" class="form-label col-md-5">
            Сумма 1 {{ professionCost.type == 'CREDIT' ? 'кредита': 'месяца' }} по программе «100»
          </label>
          <div class="col-md-7">
            <input class="form-control" id="sum" type="number" min="0" step="0.01"
                   v-model="professionCost.sum">
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-12">
      <div class="row col-md-10">
        <div class="el-input-group">
          <label for="sumNat" class="form-label col-md-5">
            Сумма 1 {{ professionCost.type == 'CREDIT' ? 'кредита': 'месяца' }} по программе «100» (Нац ВУЗ)
          </label>
          <div class="col-md-7">
            <input class="form-control" id="sumNat" type="number" min="0" step="0.01"
                   v-model="professionCost.sumNat">
          </div>
        </div>
      </div>
    </div>


    <div class="col-md-12">
      <div class="row col-md-10">
        <div class="el-input-group">
          <label for="sum118" class="form-label col-md-5">
            Сумма 1 {{ professionCost.type == 'CREDIT' ? 'кредита': 'месяца' }} по стипендиальной программе
          </label>
          <div class="col-md-7">
            <input class="form-control" id="sum118" type="number" min="0" step="0.01"
                   v-model="professionCost.sum118">
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-12">
      <div class="row col-md-10">
        <div class="el-input-group">
          <label for="sumNat118" class="form-label col-md-5">
            Сумма 1 {{ professionCost.type == 'CREDIT' ? 'кредита': 'месяца' }} по стипендиальной программе (Нац ВУЗ)
          </label>
          <div class="col-md-7">
            <input class="form-control" id="sumNat118" type="number" min="0" step="0.01"
                   v-model="professionCost.sumNat118">
          </div>
        </div>
      </div>
    </div>


    <div class="col-md-12">
      <div class="row col-md-10">
        <div class="el-input-group">
          <label for="sum124" class="form-label col-md-5">
            Сумма 1 {{ professionCost.type == 'CREDIT' ? 'кредита': 'месяца' }} по межправительственному соглашению
          </label>
          <div class="col-md-7">
            <input class="form-control" id="sum124" type="number" min="0" step="0.01"
                   v-model="professionCost.sum124">
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-12">
      <div class="row col-md-10">
        <div class="el-input-group">
          <label for="sumNat124" class="form-label col-md-5">
            Сумма 1 {{ professionCost.type == 'CREDIT' ? 'кредита': 'месяца' }} по межправительственному соглашению (Нац ВУЗ)
          </label>
          <div class="col-md-7">
            <input class="form-control" id="sumNat124" type="number" min="0" step="0.01"
                   v-model="professionCost.sumNat124">
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="page-footer justify-content-end" v-if="isAdmin()">
    <b-button variant="success" @click="onClickSave()">
      Сохранить
    </b-button>
  </div>

  <vue-loading :active.sync="isLoading" :is-full-page="true"></vue-loading>
</template>

<script>

import VueLoading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import professionCostService from "@/services/professionCostService";
import {showErrorNotify, showSuccessNotify} from "@/utils/notificationUtils";
import delegationService from "@/services/delegationService";

export default {
  components: {
    VueLoading
  },
  computed: {
    professionUuid() {
      return this.$route.params.uuid;
    }
  },
  data() {
    return {
      isLoading: false,
      professionCost: {
        year: null,
        profession: {
          code: null,
          nameRu: null
        },
        sum: null,
        sumNat: null,
        sum118: null,
        sumNat118: null,
        sum124: null,
        sumNat124: null,
      }
    };
  },
  methods: {
    init() {
      this.findById(this.professionUuid);
    },
    async findById(uuid) {
      this.isLoading = true;
      this.professionCost = await professionCostService.findByUuid(uuid);
      this.isLoading = false;
    },
    async onClickSave() {
      try {
        this.isLoading = true;
        this.professionCost = await professionCostService.save(this.professionCost);
        showSuccessNotify("Успешно сохранено!");
      } catch (exc) {
        showErrorNotify("Возникла ошибка при сохранении");
      } finally {
        this.isLoading = false;
      }
    },
    isAdmin() {
      return delegationService.isAdmin();
    },
  },
  mounted() {
    this.init();
  }
};
</script>

<style scoped>
.row {
  padding-top: 5px;
}
</style>
